import { checkResolution } from 'Functions/helpers';

const toggleTabIndex = (swiper) => {
    const slides = swiper.slides
    const itemsCount = swiper.params.slidesPerView

    for (const slide of slides) {
        for (const tabbable of slide.querySelectorAll('a, button')) {
            tabbable.tabIndex = checkResolution('cxs;xs') ? 0 : -1
        }
    }

    if (!checkResolution('cxs;xs')) {
        const tabbableSlides = [...slides].reduce((accumulator, current) => {
            if (current.classList.contains('swiper-slide-active') || (accumulator.length && accumulator.length < itemsCount)) {
                accumulator.push(current)
            }

            return accumulator
        }, [])

        for (const slide of tabbableSlides) {
            for (const tabbable of slide.querySelectorAll('a, button')) {
                tabbable.tabIndex = 0
            }
        }
    }
}

export const rSwiperTabIndex = {
    on: {
        init(swiper) {
            toggleTabIndex(swiper)
        },
        slideChangeTransitionEnd(swiper) {
            toggleTabIndex(swiper)
        },
        breakpoint(swiper) {
            toggleTabIndex(swiper)
        },
    },
}